import React, { FC } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { Box, Slide } from '@mui/material';

const PreferencesLayout: FC = () => {
  const location = useLocation();

  // Determine if we're on the edit phone page
  const isEditPhonePage = location.pathname.includes('edit-phone');

  return (
    <Box
      sx={{
        position: 'relative',
        overflow: 'hidden',
        height: '100%',
        minHeight: '80vh',
        width: '100%',
      }}
    >
      <Slide direction={isEditPhonePage ? 'left' : 'right'} in={true} mountOnEnter unmountOnExit timeout={300}>
        <Box sx={{ width: '100%', height: '100%' }}>
          <Outlet />
        </Box>
      </Slide>
    </Box>
  );
};

export default PreferencesLayout;
